export enum ButtonAction {
	BUY = "buy",
	SELL = "sell",
	SWAP = "swap",
	SEND = "send",
	SAVINGS = "savings",
	DEPOSIT = "deposit",
	WITHDRAWAL = "withdrawal",
	TRANSFER = "transfer",
	REMOVE_FROM_WATCHLIST = "remove-from-watchlist",
	ADD_ALERT = "add_alert",
	CANCEL_ORDER = "cancel_order",
	MARGIN_TRADE = "margin_trade"
}
